import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { DfpComponent } from "../../../ads/dfp-component";
import { ProfileTopPeople } from "./profile-top-people";
import { ProfileTopPlace } from "./profile-top-place";
import { ProfileTopCompanies } from "./profile-top-companies";
import { Link } from "@quintype/components";
import TrendingStories from "../trending-stories";

import "./entity-details.m.css";
import { EntityArticles } from "./entity-articles";

export const Bread = ({ url, type, name }) => {
  return (
    <div styleName="breadCrumbs-wrapper">
      <div styleName="breadcrum-items">
        <Link href={url}>{type}</Link>
        <span>/</span>
        {name}
      </div>
    </div>
  );
};

export function EntityDetails({ data = {}, config = {} }) {
  const sketchesHost = config["sketches-host"];
  const item = get(data, ["data", "entity"], []);
  const entityName = get(data, ["entityName"], []);

  const midAd1 = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "mid_page_1"], {}));
  const footerAd = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "footer_1"], {}));

  return (
    <div styleName="entity-details-container">
      {entityName === "person" && (
        <>
          <Bread url="/people" type="People" name={item?.name} />
          <ProfileTopPeople item={item} sketchesHost={sketchesHost} />
        </>
      )}
      {entityName === "place" && (
        <>
          <Bread url="/places" type="Places" name={item?.name} />
          <ProfileTopPlace item={item} sketchesHost={sketchesHost} />
        </>
      )}
      {entityName === "company" && (
        <>
          <Bread url="/companies" type="Companies" name={item?.name} />
          <ProfileTopCompanies item={item} entityName={entityName} sketchesHost={sketchesHost} />
        </>
      )}

      {entityName === "person" ? (
        <div styleName="description" dangerouslySetInnerHTML={{ __html: item?.bio }}></div>
      ) : (
        <div styleName={`description ${entityName}`} dangerouslySetInnerHTML={{ __html: item?.description }}></div>
      )}
      <div styleName="bottom-ad-container">
        <DfpComponent adStyleName={"ad-slot-size-970x250"} id={midAd1?.id} />
      </div>
      <EntityArticles name={item?.name} />
      <TrendingStories />
      <div styleName="bottom-ad-container">
        <DfpComponent adStyleName="ad-slot-size-970x250" id={footerAd?.id} />
      </div>
    </div>
  );
}
